<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar color="white" text class="elevation-0">
              <v-toolbar-title class="title font-weight-regular">Detalhes do Perfil</v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex class xs8>
            <v-card-text>
              <v-form ref="form" class="pl-6 pr-12">
                <v-layout row wrap>
                  <v-flex md4>
                    <div
                      class="subtitle-1 font-weight-regular blue--text text--darken-4 text--darken-4"
                    >Nome Completo</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      clearable
                      placeholder="Nome Completo"
                      :rules="nameRules"
                      v-model="name"
                      dense
                      type="text"
                      color="teal accent-3">
                    </v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <div class="
                         subtitle-1
                         font-weight-regular
                         blue--text
                         text--darken-4">
                      Função
                    </div>
                  </v-flex>
                  <v-flex md8>
                    <v-select
                      v-model="funcao"
                      :items="occupationsForSelect.filter(a => { return a.status === true })"
                      outlined
                      item-text="slug"
                      label="Função"
                      return-object
                      dense>
                    </v-select>
                  </v-flex>
                  <v-flex md4>
                    <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Email</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      placeholder="E-mail"
                      outlined
                      dense
                      v-model="email"
                      :rules="emailRules"
                      type="email"
                      color="teal accent-3"
                    ></v-text-field>
                  </v-flex>
                  <!--Base-->
                  <v-flex md4>
                    <div class="
                      subtitle-1
                      font-weight-regular
                      blue--text
                      text--darken-4">Base</div>
                  </v-flex>
                  <v-flex md8>
                    <v-select
                      dense
                      :items="basesForSelect.filter(a => { return a.status === 1 })"
                      return-object
                      v-model="baseSelected"
                      label="Base"
                      color="teal accent-3"
                      outlined>
                    </v-select>
                  </v-flex>
                  <!--/Base-->
                  <v-flex md4>
                    <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Telefone</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      v-mask="mask.telephone"
                      v-model="telephone"
                      dense
                      placeholder="Telefone"
                      :rules="phoneRules"
                      outlined
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="mt-2" row wrap>
                  <v-flex class="mb-3" md12>
                    <div class="title font-weight-regular">Adicionar Senha</div>
                  </v-flex>
                  <v-flex md4>
                    <div class="subtitle-1 font-weight-regular blue--text text--darken-4">Senha</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      dense
                      placeholder="Senha"
                      v-model="password"
                      :type="show_password ? 'text' : 'password'"
                      @click:append="show_password = !show_password"
                      :rules="passwordRules"
                      color="teal accent-3"
                    ></v-text-field>
                  </v-flex>

                  <v-flex md4>
                    <div
                      class="subtitle-1 font-weight-regular blue--text text--darken-4"
                    >Confirmar Senha</div>
                  </v-flex>
                  <v-flex md8>
                    <v-text-field
                      outlined
                      dense
                      placeholder="Confirmar Senha"
                      v-model="confirmPassword"
                      :type="show_password ? 'text' : 'password'"
                      @click:append="show_password = !show_password"
                      :rules="[confirmPasswordRules]"
                      color="teal accent-3"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout column wrap>
                  <div v-if="textError">{{textError}}</div>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="body-2 white--text"
                    @click="newUser"
                    color="primary"
                    depressed
                    :loading="loading">
                    Cadastrar Usuário
                  </v-btn>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  name: "NewUser",
  directives: { mask },
  data: () => ({
    textError: undefined,
    mask: {
      telephone: "(##) #####-####"
    },
    telephone: undefined,
    name: undefined,
    avatar: undefined,
    base:undefined,
    funcao:undefined,
    cargos: ["Administrador", "Tarm", "Medico Regulador"],
    state: undefined,
    stateOptions: [
      "Acre (AC)",
      "Alagoas (AL)",
      "Amapá (AP)",
      "Amazonas (AM)",
      "Bahia (BA)",
      "Ceará (CE)",
      "Distrito Federal (DF)",
      "Espírito Santo (ES)",
      "Goiás (GO)",
      "Maranhão (MA)",
      "Mato Grosso (MT)",
      "Mato Grosso do Sul (MS)",
      "Minas Gerais (MG)",
      "Pará (PA)",
      "Paraíba (PB)",
      "Paraná (PR)",
      "Pernambuco (PE)",
      "Piauí (PI)",
      "Rio de Janeiro (RJ)",
      "Rio Grande do Norte (RN)",
      "Rio Grande do Sul (RS)",
      "Rondônia (RO)",
      "Roraima (RR)",
      "Santa Catarina (SC)",
      "São Paulo (SP)",
      "Sergipe (SE)",
      "Tocantins (TO)"
    ],
    email: undefined,
    password: undefined,
    confirmPassword: undefined,
    show_password: false,
    image: "",
    nameRules:[
      v=> !!v || 'Nome do solicitante precisa ser preenchido!',
      v=> (v && /^[A-Za-zàáãäâèéëêìíïîòóõöôùúüûç ]+$/.test(v)) || 'Somente letras!'
    ],
    occupationRules: [/* v => !!v || "Função precisa ser preenchido!" */],
    emailRules: [
      v => !!v || 'E-mail precisa ser preenchido!',
      v => /.+@.+\..+/.test(v) || 'E-mail não é válido!',
    ],
    baseRules: [/* v => !!v || "Base precisa ser preenchido!" */],
    phoneRules: [v => !!v || "Telefone precisa ser preenchido!"],
    passwordRules: [v => !!v || "Senha precisa ser preenchido!"],
    loading:false,
    baseSelected: ''
  }),

  created () {
    this.initialize();
  },

  computed: {

    bases () {
      let bases = this.$store.getters.bases;
      return bases;
    },

    occupations () {
      let occupations = this.$store.getters.rules;
      return occupations;
    },

    occupationsForSelect () {
      let occupationsf = this.occupations.map( occupation =>{
        return {
          value: occupation.id,
          text: occupation.name,
          status: occupation.status,
          slug: occupation.display_name,
        };
      });
      return occupationsf;
    },

    basesForSelect (){
      let basef = this.bases.map( base =>{
        return {
          value: base.id,
          text: base.name,
          status: base.status,
        };
      })
      return basef
    },

    confirmPasswordRules (){
      if(!this.confirmPassword)
        return "Confirmar senha precisa ser preenchido!"
      if(this.password && this.confirmPassword && this.confirmPassword != this.password)
        return 'As senhas são diferentes!'
      return false
    },

  },
  watch: {
  },
  methods: {

    async initialize () {

      await this.$store.dispatch('loadRules');
      await this.$store.dispatch('downloadBases');
    },

    async newUser () {
      this.setErrorSave(undefined);
      if(this.$refs.form.validate()){
        this.loading = true;
        console.log('?', this.funcao)
        let fun = []
        fun.push(this.funcao)
        let employee = {
          name: this.name,
          email: this.email,
          document: this.document?this.document: new Date().getTime()+'',
          phone: this.telephone,
          password: this.password,
          status:1,
          roles:fun.map( f => f.value ),
          base_id: this.baseSelected.value,
        }
        console.log('e', employee)
        await this.$store.dispatch("addNewEmployee",employee)
          .then( resolve => {
            this.loading = false
            if(resolve.status){
              this.$refs.form.resetValidation()
              this.$refs.form.reset()
              this.$router.back()
            }
            else{
              console.log(resolve)
              if (resolve.response) {
                this.setErrorSave(resolve.response.data.message);
              }
              else if (resolve.request) {
                this.setErrorSave(resolve.request.response.data.message);
              }
              else {
                this.setErrorSave(resolve.message);
              }
            }
          })
          .catch( error => {
            this.setErrorSave(error.message);
            console.log(error)
            this.loading = false
          })
      }
    },

    setErrorSave (errorMsg) {
      this.textError = errorMsg;
    }
  }
};
</script>
